import axios from '@axios'

export default {
  namespaced: true,
  state: {},
  getters: {},
  mutations: {},
  actions: {
    fetchMyChildrenList(ctx, queryParams) {
      return new Promise((resolve, reject) => {
        axios
          .get('/my-children', {
            params: queryParams,
          })
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
  },
}
